import { useCallback, useEffect, useMemo, useState } from 'react';
import { PAYMENT_KEYS, TRANSFER_METHODS } from './store';

let snapshot = null;
let pending = null;
const listeners = new Set();

function fetchPayment() {
  if (pending) return pending;
  pending = fetch('/api/payment', { credentials: 'same-origin' })
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      snapshot = data?.payment ?? {};
      return snapshot;
    })
    .catch(() => {
      snapshot = snapshot ?? {};
      return snapshot;
    })
    .finally(() => {
      pending = null;
      listeners.forEach((update) => update(snapshot));
    });
  return pending;
}

export function usePayment() {
  const [saved, setSaved] = useState(snapshot);

  useEffect(() => {
    listeners.add(setSaved);
    if (snapshot === null) fetchPayment();
    else setSaved(snapshot);
    return () => {
      listeners.delete(setSaved);
    };
  }, []);

  const reload = useCallback(() => {
    fetchPayment();
  }, []);

  const payment = useMemo(() => {
    const clean = (value) => String(value ?? '').replace(/\s+/g, ' ').trim().slice(0, 60);
    return Object.fromEntries(PAYMENT_KEYS.map((key) => [key, clean(saved?.[key])]));
  }, [saved]);

  const methods = useMemo(
    () =>
      TRANSFER_METHODS.map((method) => ({ ...method, number: payment[method.id] })).filter(
        (method) => method.number
      ),
    [payment]
  );

  return { ready: saved !== null, payment, whatsapp: payment.whatsapp, methods, reload };
}
